import * as yup from "yup";

const schema = yup.object().shape({
  predefinedMessageName: yup
    .string()
    .min(3, "Minimum 3 characters")
    .max(255, "Maximum 255 characters")
    .required("Name is required"),
  predefinedMessageSkill: yup
    .string()
    .nullable(true)
    .when("predefinedMessageGlobal", {
      is: false,
      then: yup
        .string()
        .nullable(true)
        .required("Select skill or enable global mode"),
      otherwise: yup.string().nullable(true),
    }),
  predefinedMessageGlobal: yup.boolean().required("Global is required"),
  //predefinedMessageType: yup.string().required("Tipo é obrigatório por favor selecione uma skill ou modo global"),
  predefinedMessageText: yup.string().required("Text is required"),
  predefinedMessageActivated: yup.boolean().required("Activated is required"),

  predefinedMessageFiles: yup.object().shape({
    data: yup.string(),
    mimeType: yup.string(),
    fileName: yup.string(),
  })
});

export default schema; 
